﻿import config from "../config"

export default {
    list: {
        url: config.base_url + "lz_sub_area/list/{gardenId}",
        type: "get",
    }
    ,
    save: {
        url: config.base_url + "lz_sub_area/save",
        type: "post",
    }
    ,
    saveAll: {
        url: config.base_url + "lz_sub_area/saveAll",
        type: "post",
    }
    ,
    remove:{
        url: config.base_url + "lz_sub_area/delete",
        type: "get",
    }
}

